import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {Gap} from '../../../../app/value-tracker/_models/Gap';
import { SubheaderHandlerService } from '../../../shared/services/subheader-handler.service';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-selected-gaps',
  templateUrl: './selected-gaps.component.html'
})
export class SelectedGapsComponent implements OnInit {
  @Input() gap: Gap;
  @Output() buttonAddDetailsEmit = new EventEmitter<Gap>();
  @Output() buttonDeleteEmit = new EventEmitter<Gap>();
  @Input() showDelete: boolean;
  translatedText = [];
  constructor(
    private subHeaderService: SubheaderHandlerService,
    private translate: TranslateService) {
      translate.get([
        'GAPS.GAP_NAME',
        'GAPS.ADD_DETAILS',
      ]).subscribe((translations: string) => {
        this.translatedText[0] = translations['GAPS.GAP_NAME'];
        this.translatedText[1] = translations['GAPS.ADD_DETAILS'];
      });
     }

  ngOnInit() {
  }

  addGapsDetails() {
    this.buttonAddDetailsEmit.emit(this.gap);
  }
  deleteMyGaps() {
    this.buttonDeleteEmit.emit(this.gap);
  }

  selectClassForStatus(status: string): string {
    if (status === 'Completed') {
        return 'badge badge-pill completed';
    }
    if (status === 'Pending') {
        return 'badge badge-pill pending';
    }
    if (status === 'In Progress') {
      return 'badge badge-pill in-progress';
    }
    return null;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/selected-gaps/selected-gaps.component.ts